export default "__VITE_ASSET__MiBSFEoD__"